<div id="convenios-popup" class="common-company-popup popup-md">
    <form class="form" role="form" autocomplete="off" [formGroup]="addConvenioAtributoForm" >
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Convenios</h2>
        </div>
        <div class="popoup-content">
            <div class="block-looper">
                <div class="form-wrap w40">
                    <mat-label aria-label="" class="label">Tipo</mat-label>
                    <mat-form-field appearance="fill">
                        <mat-select formControlName="tipoAtributo" >
                            <mat-option *ngFor="let atributo of dataSourceNullAttributo" [value]="atributo.attributoValue" >{{ atributo.attributoName }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error
                    *ngIf="addConvenioAtributoForm.get('tipoAtributo').invalid && addConvenioAtributoForm.get('tipoAtributo').touched">
                    <span *ngIf="addConvenioAtributoForm.get('tipoAtributo').hasError('required')"> El tipo es obligatorio</span>
                    </mat-error>
                </div>
                <div class="form-wrap w20">
                    <mat-label aria-label="" class="label">Atributo</mat-label>
                    <mat-form-field appearance="fill">
                        <input type="text" matInput placeholder=""  formControlName="atributo">
                    </mat-form-field>
                    <mat-error
                    *ngIf="addConvenioAtributoForm.get('atributo').invalid && addConvenioAtributoForm.get('atributo').touched">
                    <span *ngIf="addConvenioAtributoForm.get('atributo').hasError('required')"> El atributo es obligatorio</span>
                    </mat-error>
                </div>
                <div class="form-wrap w40">
                    <mat-label aria-label="" class="label">Convenio</mat-label>                   
                    <mat-form-field appearance="fill" class="multi-select-group">
                        <mat-select formControlName="convenioId">
                            <mat-option>Ninguno</mat-option>
                            <mat-optgroup *ngFor="let group of convenioList" [label]="group.name">
                                <mat-option *ngFor="let convenio of group.data" [value]="convenio.convenioId">
                                    {{convenio.nombre}}</mat-option>
                            </mat-optgroup>
                        </mat-select>
                    </mat-form-field>
                    <mat-error
                    *ngIf="addConvenioAtributoForm.get('convenioId').invalid && addConvenioAtributoForm.get('convenioId').touched">
                    <span *ngIf="addConvenioAtributoForm.get('convenioId').hasError('required')"> El convenio es obligatorio</span>
                    </mat-error>
                </div>
                <div class="form-wrap w20 suff">
                    <mat-label aria-label="" class="label">Salario bruto</mat-label>
                    <mat-form-field appearance="fill">
                        <input type="text" matInput placeholder="" formControlName="salarioBruto" appSpanishNumber>
                        <span matSuffix>&nbsp; €</span>
                    </mat-form-field>
                    <mat-error
                    *ngIf="addConvenioAtributoForm.get('salarioBruto').invalid && addConvenioAtributoForm.get('salarioBruto').touched">
                    <span *ngIf="addConvenioAtributoForm.get('salarioBruto').hasError('required')"> El salario bruto es obligatorio</span>
                    </mat-error>
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="keep"><span (click)="saveConvenioAtributo()" class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="cancel()"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>